import React, { Component } from "react";
import VaccinationGraph from "./VaccinationGraph";
import VaccinationGraphBar from "./VaccinationGraphBar";
import VaccinationGraphMultiple from "./VaccinationGraphMultiple";
import { Link } from "react-router-dom";

class VaccinationMaricopa extends Component {
  constructor() {
    super();
    this.state = {
      dates: undefined,
      vaccineFullPop: undefined,
      vaccineFull12: undefined,
      vaccineFull18: undefined,
      dailyVacData: undefined,
      vaccineOneShot: undefined,
    };
  }
  componentWillMount() {
    fetch(
      "https://data.cdc.gov/resource/8xkx-amqh.json?recip_county=Maricopa County"
    )
      .then((response) => response.json())
      .then((data) => {
        const dates = data.map((a) => a.date).reverse();
        const vaccineFullPop = data
          .map((a) => a.series_complete_pop_pct)
          .reverse();
        const vaccineOneShot = data
          .map((a) => a.administered_dose1_pop_pct)
          .reverse();
        const vaccineFull12 = data
          .map((a) => a.series_complete_12pluspop)
          .reverse();
        const vaccineFull18 = data
          .map((a) => a.series_complete_18pluspop)
          .reverse();
        const vaccineFull65 = data
          .map((a) => a.series_complete_65pluspop)
          .reverse();
               const oneShot12 = data
          .map((a) => a.administered_dose1_recip_12pluspop_pct)
          .reverse();
          const oneShot18 = data
          .map((a) => a.administered_dose1_recip_18pluspop_pct)
          .reverse();
          const oneShot65 = data
          .map((a) => a.administered_dose1_recip_65pluspop_pct)
          .reverse();
        let newDates = [];
        let dailyVacData = data.map((a) => a.series_complete_yes).reverse();
        let newDailyVacData = [];
        for (var i = 0; i < dates.length; i++) {
          newDates.push(dates[i].slice(0, 10));
        }
        for (var j = 0; j < dailyVacData.length; j++) {
          if (j === 0) {
            newDailyVacData.push(dailyVacData[j]);
          } else {
            let result = 0;
            result = dailyVacData[j] - dailyVacData[j - 1];
            newDailyVacData.push(result);
          }
        }
        this.setState({
          dates: newDates,
          vaccineFullPop: vaccineFullPop,
          vaccineFull12: vaccineFull12,
          vaccineFull18: vaccineFull18,
          vaccineFull65: vaccineFull65,
          dailyVacData: newDailyVacData,
          vaccineOneShot: vaccineOneShot,
           oneShot12:oneShot12,
          oneShot18:oneShot18,
          oneShot65:oneShot65,
        });
      });
  }
  render() {
    const {
      dates,
      vaccineFullPop,
      vaccineFull12,
      vaccineFull18,
      vaccineFull65,
      dailyVacData,
      vaccineOneShot,
          oneShot12,
      oneShot65,
      oneShot18
    } = this.state;
    return (
      <>
        <div className="row my-4">
          <div className="col-md-12">
            <div className="nav py-3 border-bottom-gray">
              <div className="tabs">
                <Link to="/vaccination-pima" className="tab tab-inactive">
                  Pima
                </Link>
                <Link to="/vaccination-maricopa" className="tab ">
                  Maricopa
                </Link>
                <Link to="/vaccination-arizona" className="tab tab-inactive">
                  Arizona
                </Link>
                <Link to="/vaccination-comparison" className="tab tab-inactive">
                  Comparison
                </Link>
              </div>
            </div>
          </div>
        </div>
 <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County daily Vaccinations for COVID-19
            <br />
          </h1>
          <VaccinationGraphBar
            x={dates}
            y={dailyVacData}
            name={"Daily Vaccinations"}
            xaxistitle={"Date"}
            color={"red"}
            title={`<b style='font-size:32px;color:black'>Maricopa County daily Vaccinations for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people fully vaccinated for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={vaccineFullPop}
            name={"% of people fully vaccinated"}
            xaxistitle={"Date"}
            color={"red"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people fully vaccinated for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people with at least one shot for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={vaccineOneShot}
            name={"% of people vaccinated"}
            xaxistitle={"Date"}
            color={"red"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people with at least one shot for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people 12+ fully vaccinated for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={vaccineFull12}
            name={"% of people fully vaccinated"}
            xaxistitle={"Date"}
            color={"blue"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people 12+ fully vaccinated for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people 12+ with at least one shot for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={oneShot12}
            name={"% of people vaccinated"}
            xaxistitle={"Date"}
            color={"blue"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people 12+ fully with at least one shot for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people 18+ fully vaccinated for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={vaccineFull18}
            name={"% of people fully vaccinated"}
            xaxistitle={"Date"}
            color={"green"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people 18+ fully vaccinated for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people 18+ with at least one shot for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={oneShot18}
            name={"% of people vaccinated"}
            xaxistitle={"Date"}
            color={"green"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people 18+ fully with at least one shot for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people 65+ fully vaccinated for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={vaccineFull65}
            name={"% of people fully vaccinated"}
            xaxistitle={"Date"}
            color={"orange"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people 65+ fully vaccinated for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County % of people 65+ with at least one shot for COVID-19
            <br />
          </h1>
          <VaccinationGraph
            x={dates}
            y={oneShot65}
            name={"% of people vaccinated"}
            xaxistitle={"Date"}
            color={"orange"}
            title={`<b style='font-size:32px;color:black'>Maricopa County % of people 65+ fully with at least one shot for COVID-19</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County Comparison of Vaccinated People by Group of age
            <br />
          </h1>
          <VaccinationGraphMultiple
            x={dates}
            y1={vaccineFull12}
            y2={vaccineFull18}
            y3={vaccineFull65}
            name1={"Group 12+"}
            name2={"Group 18+"}
            name3={"Group 65+"}
            xaxistitle={"Date"}
            ytitle={"% of people fully vaccinated"}
            color1={"red"}
            color2={"blue"}
            color3={"green"}
            title={`<b style='font-size:32px;color:black'>Maricopa County Comparison of Vaccinated People by Group of age</b>`}
          />
        </div>
        <div className="my-5">
          <h1 style={{ marginBottom: "-82px", fontWeight: "bold" }}>
            Maricopa County Comparison of Vaccinated People by Group of age with one shot
            <br />
          </h1>
          <VaccinationGraphMultiple
            x={dates}
            y1={oneShot12}
            y2={oneShot18}
            y3={oneShot65}
            name1={"Group 12+"}
            name2={"Group 18+"}
            name3={"Group 65+"}
            xaxistitle={"Date"}
            ytitle={"% of people fully vaccinated"}
            color1={"red"}
            color2={"blue"}
            color3={"green"}
            title={`<b style='font-size:32px;color:black'>Maricopa County Comparison of Vaccinated People by Group of age with one shot</b>`}
          />
        </div>
      </>
    );
  }
}
export default VaccinationMaricopa;
